module.exports = __webpack_public_path__ + "img/goods16_5.21178cd1.jpg";